import React            from "react";

function CovidRiskCheckerSelectedSymptoms({symptoms}) {
  return (
    <div className="covid-symptoms">      
      <div className="d-flex symptom-row">
        <div className="col-12 col-lg-10 w-100">
          <label className="field-label">Symptoms</label>
          <ul>
            {
              symptoms.map((symptom, index) => {
                return <li key={`symptom-${index}`}>{symptom}</li>
              })
            }
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CovidRiskCheckerSelectedSymptoms;
